module.exports = __webpack_public_path__ + "img/game--apex-legends--pegi.4269a853.png";